import * as types from '../actions/external-integration-actions-types';

// Authorise Zoom Oauth
const ORG_ZOOM_OAUTH_INITIAL_STATE = {
	isLoading: false,
	results: {},
	error: '',
};

// Launchdeck version
export function getZoomOauthRedirectReducer(state = ORG_ZOOM_OAUTH_INITIAL_STATE, action) {
	switch (action.type) {
		case types.ORG_ZOOM_OAUTH_REQUEST:
			return { ...state, isLoading: true, results: [] };
		case types.ORG_ZOOM_OAUTH_SUCCESS:
			return { ...state, isLoading: false, results: action.payload };
		case types.ORG_ZOOM_OAUTH_FAILURE:
			return { ...state, isLoading: false, error: 'Error while trying to initiate Zoom Oauth' };
		default:
			return state;
	}
}

